import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {FinanzamtDTO} from '../../openapi/schluesseldaten-openapi';


export const finanzamtEntitiesAdapter: EntityAdapter<FinanzamtDTO> = createEntityAdapter<FinanzamtDTO>({
  selectId: (entity: FinanzamtDTO) => entity.finanzamtsbezeichnung!,
});
